/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import {
  paperlessPageEnabled
} from 'services/FeatureFlags';

export const DEFAULT_REQUIRED_REQUEST_STATE = [
  'userEntitlements',
  'accounts',
  'customer',
  'metadata'
];

const DASHBOARD_REQUEST_STATES = [
  ...DEFAULT_REQUIRED_REQUEST_STATE,
  'mmrMessages',
  'workspacePreferences'
];

const ACCOUNTS_REQUEST_STATES = [...DEFAULT_REQUIRED_REQUEST_STATE];

const ACCOUNT_DETAILS_REQUEST_STATES = [
  ...DEFAULT_REQUIRED_REQUEST_STATE,
  'pendingTransactions',
  'accountHistory',
  'historicalBalances',
  'individualAccountGrowth',
  'taxes'
];

const TRANSACTIONS_REQUEST_STATES = [
  ...DEFAULT_REQUIRED_REQUEST_STATE,
  'historicalTransactions',
  'pendingTransactions'
];

const TRANSACTIONS_REQUEST_STATES_V2 = [
  ...DEFAULT_REQUIRED_REQUEST_STATE,
  'historicalTransactionsV2'
]

const PERFORMANCE_REQUEST_STATES = [
  ...DEFAULT_REQUIRED_REQUEST_STATE,
  'pendingTransactions'
];

const STATEMENTS_REQUEST_STATES = [
  ...DEFAULT_REQUIRED_REQUEST_STATE,
  'documentReferences'
];

const TAXES_REQUEST_STATES = [...DEFAULT_REQUIRED_REQUEST_STATE, 'taxes'];
const BALANCE_DETAILS_REQUEST_STATES = [...DEFAULT_REQUIRED_REQUEST_STATE];

export const PREFERENCES_REQUEST_STATES = [
  ...DEFAULT_REQUIRED_REQUEST_STATE,
  'customerPreferences'
];

const COST_BASIS_REQUEST_STATES = [
  ...PREFERENCES_REQUEST_STATES,
  'taxes',
  'pendingTransactions'
];

const DIVIDENDS_AND_CAPITAL_GAINS_REQUEST_STATES = [
  ...PREFERENCES_REQUEST_STATES,
  'dividendsCapitalGains'
];

const LINKED_BANK_ACCOUNTS = [...PREFERENCES_REQUEST_STATES, 'bankProfile'];

const SUBSCRIPTIONS_REQUEST_STATES = [
  ...PREFERENCES_REQUEST_STATES,
  'mutualFunds',
  'subscriptions'
];

const DOCUMENT_DELIVERY_REQUEST_STATES = [
  ...PREFERENCES_REQUEST_STATES,
  'mutualFunds',
  'documentDelivery'
];

const BENEFITS_REQUEST_STATES = [...DEFAULT_REQUIRED_REQUEST_STATE, 'benefits'];

const MESSAGE_CENTER_REQUEST_STATES = ['accounts', 'customer'];

const SUMMIT_BASE_REQUEST_STATES = [
  ...DEFAULT_REQUIRED_REQUEST_STATE,
  'householdInformation'
];

const ERROR_REQUEST_STATE = [...DEFAULT_REQUIRED_REQUEST_STATE];

const BENEFICIARIES_REQUEST_STATES = [
  ...DEFAULT_REQUIRED_REQUEST_STATE,
  'beneficiaries'
];

const GRANT_VIEW_ACCESS_REQUEST_STATES = [
  ...PREFERENCES_REQUEST_STATES,
  'viewRelationships'
];

const ALERTS_AND_NOTIFICATIONS_REQUEST_STATES = [
  ...PREFERENCES_REQUEST_STATES,
  'alertPreferences',
  'activatedForTextAlerts',
  'securityOperationalConsent'
];

DASHBOARD_REQUEST_STATES.push('portfolio')
ACCOUNTS_REQUEST_STATES.push('portfolio')
PERFORMANCE_REQUEST_STATES.push('portfolio')
ACCOUNT_DETAILS_REQUEST_STATES.push('portfolio')

if(paperlessPageEnabled()) {
  DOCUMENT_DELIVERY_REQUEST_STATES.push('paperlessDisclosure');
}

export const requestStateConfig = {
  '': DASHBOARD_REQUEST_STATES,
  accounts: ACCOUNTS_REQUEST_STATES,
  'account-details': ACCOUNT_DETAILS_REQUEST_STATES,
  'client-services-benefits': BENEFITS_REQUEST_STATES,
  'balance-details': BALANCE_DETAILS_REQUEST_STATES,
  dashboard: DASHBOARD_REQUEST_STATES,
  'enhanced-personal-services-benefits': BENEFITS_REQUEST_STATES,
  error: ERROR_REQUEST_STATE,
  performance: PERFORMANCE_REQUEST_STATES,
  'personal-services-benefits': BENEFITS_REQUEST_STATES,
  profile: PREFERENCES_REQUEST_STATES,
  'profile/alerts-and-notifications': ALERTS_AND_NOTIFICATIONS_REQUEST_STATES,
  'profile/contact-information': PREFERENCES_REQUEST_STATES,
  'profile/trusted-contacts': PREFERENCES_REQUEST_STATES,
  'profile/beneficiaries': BENEFICIARIES_REQUEST_STATES,
  'profile/checkwriting': PREFERENCES_REQUEST_STATES,
  'profile/customize-account-view': PREFERENCES_REQUEST_STATES,
  'profile/grant-view-access': GRANT_VIEW_ACCESS_REQUEST_STATES,
  'profile/cost-basis': COST_BASIS_REQUEST_STATES,
  'profile/dividends-and-capital-gains':
    DIVIDENDS_AND_CAPITAL_GAINS_REQUEST_STATES,
  'profile/linked-bank-accounts': LINKED_BANK_ACCOUNTS,
  'profile/subscriptions': SUBSCRIPTIONS_REQUEST_STATES,
  'profile/document-delivery': DOCUMENT_DELIVERY_REQUEST_STATES,
  statements: STATEMENTS_REQUEST_STATES,
  taxes: TAXES_REQUEST_STATES,
  transactions: TRANSACTIONS_REQUEST_STATES,
  transactionsV2: TRANSACTIONS_REQUEST_STATES_V2,
  'turbotax-benefits': BENEFITS_REQUEST_STATES,
  'message-center': MESSAGE_CENTER_REQUEST_STATES,
  'program-benefits': SUMMIT_BASE_REQUEST_STATES
};
